import { $Elements, BrowserEvents, Classes, Elements } from '../global/constants';

;(function($) {

	$Elements.document.on(BrowserEvents.page.enter, () => {

		// ---------- Handle Form ----------

		function handleForm(form, params) {

			const formContent = form.find('.form-content');
			const formDone = form.find('.form-done');
			const formSuccess = formDone.find('.success');
			const formError = formDone.find('.error');

			form.parsley().on('form:submit', function() {

				Elements.LoadingBar.classList.add(Classes.loading);

				const formData = new FormData(form[0]);
				formData.append('action', params.action);
				formData.append('nonce', params.nonce);

				$.ajax({
					url: params.url,
					type: 'POST',
					dataType: 'json',
					data: formData,
					processData: false,
					contentType: false,
				}).always(function(response) {

					if(response.success === true) {
						formSuccess.removeClass(Classes.hidden);
					}
					else {
						formError.removeClass(Classes.hidden);
						console.error(response);
					}

					Elements.LoadingBar.classList.remove(Classes.loading);
					formContent.addClass(Classes.hidden);
					formDone.removeClass(Classes.hidden);
				});

				return false;
			});
		}

		// ---------- Contact Form ----------

		if(typeof contact_form_params !== 'undefined') {

			$('form.contact-form').each(function() {
				handleForm($(this), contact_form_params);
			});
		}

	});

}(jQuery));
